import {
  API_TYPES,
  WorkplaceChargeLeadTimeDifferentialPostBodySchema,
  WorkplaceChargeLeadTimeDifferentialResponseSchema,
} from "@clipboard-health/contract-backend-main";
import { post } from "@src/appV2/api/parsedApi";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { invalidateWorkplaceChargeLeadTimeDifferentialsQueries } from "./invalidateWorkplaceChargeLeadTimeDifferentialsQueries";

interface CreateWorkplaceChargeLeadTimeDifferentialParams {
  workplaceId: string;
  thresholdInHours: number;
  incrementalMultiplier: number;
}

export function useCreateWorkplaceChargeLeadTimeDifferential() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: CreateWorkplaceChargeLeadTimeDifferentialParams) => {
      const { workplaceId, thresholdInHours, incrementalMultiplier } = params;
      const url = `${environmentConfig.REACT_APP_BASE_API_URL}/workplaces/${workplaceId}/charge-lead-time-differentials`;

      const response = await post({
        url,
        data: {
          data: {
            type: API_TYPES.workplaceChargeLeadTimeDifferential,
            attributes: { thresholdInHours, incrementalMultiplier },
          },
        },
        bodySchema: WorkplaceChargeLeadTimeDifferentialPostBodySchema,
        responseSchema: WorkplaceChargeLeadTimeDifferentialResponseSchema,
      });

      return response.data;
    },
    onSuccess: (_, variables) => {
      invalidateWorkplaceChargeLeadTimeDifferentialsQueries(queryClient, variables.workplaceId);
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.CREATE_WORKPLACE_CHARGE_LEAD_TIME_DIFFERENTIAL_FAILURE,
    },
  });
}
